var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "toast-container" }, [
    _c(
      "div",
      { staticClass: "unsubscribe-btn", on: { click: _vm.unsubscribe } },
      [_c("p", [_vm._v("Unsubscribe")])]
    ),
    _vm._v(" "),
    _vm.isToastVisible
      ? _c(
          "div",
          {
            staticClass: "msg-container",
            class: { "success-bg": _vm.isSuccess },
          },
          [
            _c("p", [_vm._v(_vm._s(_vm.message))]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: "/images/ui/exit-button.png" },
              on: { click: _vm.hideToastNotification },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }